import { headerHeight } from "../helpers";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSiteHeader = (context) => {
  if (!context) return;

  const addHeaderPadding = () => {
    if (window.innerWidth <= 768) {

      if(document.querySelector('.announcement-bar')!= null){
        document.querySelector('main.main-content').style.paddingTop = `${headerHeight()}px` - `${document.querySelector('.announcement-bar')?.innerHeight}px` ;
      }else {
        document.querySelector('main.main-content').style.paddingTop = `${headerHeight()}px`;
      }
    } else if (
      !document.querySelector('body').classList.contains('template-index') &&
      !document.querySelector('body').classList.contains('template-page--about') &&
      !document.querySelector('body').classList.contains('template-page--archive') &&
      !document.querySelector('body').classList.contains('template-page-legal') &&
      !document.querySelector('body').classList.contains('template-404') &&
      !document.querySelector('body').classList.contains('template-page--archive') &&
      !document.querySelector('body').classList.contains('template-page-collaborations') &&
      !document.querySelector('body').classList.contains('template-product') &&
      !document.querySelector('body').classList.contains('template-page-landing-sign-up')
    ) {
      document.querySelector('main.main-content').style.paddingTop = `${headerHeight()}px`;
    } else {
      document.querySelector('main.main-content').style.paddingTop = '';
    }
  }
  addHeaderPadding();
  ['resize', 'orientationchange'].forEach(evt => {
    window.addEventListener(evt, () => {
      addHeaderPadding();
    });
  });

  const desktopContainer = context.querySelector('.header__container--desktop');
  if (desktopContainer) {
    if (document.querySelector('body').classList.contains('template-page--archive')) {
      if (!document.querySelector('body').classList.contains('template-page-archive')) {
        var timer = setTimeout(() => {
          desktopContainer.classList.add('slided-up');
        }, 4000);
        window.addEventListener('mousemove', () => {
          if (desktopContainer.classList.contains('slided-up')) {
            desktopContainer.classList.remove('slided-up');
          }
          clearTimeout(timer);
          timer = setTimeout(() => {
            desktopContainer.classList.add('slided-up');
          }, 4000);
        });
      }
    }

    const logo = desktopContainer.querySelector('.header__logo');
    const secondLevels = desktopContainer.querySelectorAll('.header__second-level');
    const firstLevels = desktopContainer.querySelectorAll('.header__first-level--subnav .header-first-level__link');
    secondLevels.forEach((secondLevel, index) => {
      secondLevel.addEventListener('mouseenter', () => {
        const firstLevelLink = secondLevel.closest('.header__first-level').querySelector('.header-first-level__link');
        firstLevelLink.classList.add('hover');
        logo.classList.add('white');
        if (index > 0) {
          secondLevel.closest('.header__links-list').querySelector('.inside-square').classList.add('white');
        }
      });

      secondLevel.addEventListener('mouseleave', () => {
        const firstLevelLink = secondLevel.closest('.header__first-level').querySelector('.header-first-level__link');
        firstLevelLink.classList.remove('hover');
        logo.classList.remove('white');
        if (index > 0) {
          secondLevel.closest('.header__links-list').querySelector('.inside-square').classList.remove('white');
        }
      });
    });

    firstLevels.forEach((firstLevel, index) => {
      firstLevel.addEventListener('mouseenter', () => {
        logo.classList.add('white');
        if (index > 0) {
          firstLevel.closest('.header__links-list').querySelector('.inside-square').classList.add('white');
        }
      });
      firstLevel.addEventListener('mouseleave', () => {
        if (index > 0) {
          firstLevel.closest('.header__links-list').querySelector('.inside-square').classList.remove('white');
        }
      });
    });
  }

  const mobileContainer = context.querySelector('.header__container--mobile');
  if (mobileContainer) {
    const menuIcon = mobileContainer.querySelector('.header__sitcky-element--menu-toggle');
    menuIcon.addEventListener('click', () => {
      if (menuIcon.classList.contains('open')) {
        document.querySelector('html').style.overflow = '';
        menuIcon.classList.remove('open');
      } else {
        document.querySelector('html').style.overflow = 'hidden';
        menuIcon.classList.add('open');
      }
    });

    const levelsContainer = mobileContainer.querySelector('.header__links-container');
    const sublevels = mobileContainer.querySelectorAll('.header__first-level--subnav');
    const sublevelsChild = mobileContainer.querySelectorAll('.header__second-level--subnav');
    if (sublevels.length > 0 && levelsContainer) {
      sublevels.forEach(sublevel => {
        const firstLevelLink = sublevel.querySelector('.header-first-level__link');
        const secondLevel = sublevel.querySelector('.header__second-level');
        const secondLevelClose = secondLevel.querySelector('.header-second-level__link--close');

        firstLevelLink.addEventListener('click', () => {
          levelsContainer.classList.add('second-level');
          secondLevel.classList.add('open');
        });

        secondLevelClose.addEventListener('click', () => {
          levelsContainer.classList.remove('second-level');
          secondLevel.classList.remove('open');
        });
      });
    }

    if (sublevelsChild.length > 0) {
      sublevelsChild.forEach(childLevel => {
        const secondLevelLink = childLevel.querySelector('.header-second-level__link');
        const thirdLevel = childLevel.querySelector('.header__third-level');
        const secondLevel = childLevel.closest('.header__second-level');
        const thirdLevelClose = thirdLevel.querySelector('.header-third-level__link--close');

        secondLevelLink.addEventListener('click', () => {
          levelsContainer.classList.add('second-level');
          secondLevel.classList.add('third-level');
          thirdLevel.classList.add('open')
        });

        thirdLevelClose.addEventListener('click', () => {
          levelsContainer.classList.remove('second-level');
          thirdLevel.classList.remove('open');
          secondLevel.classList.remove('third-level');
        });
      });
    }
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#header'), (el) => {
    window.dAgency.initSiteHeader(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#header'), (el) => {
      window.dAgency.initSiteHeader(el);
    });
  });
}
